//import { width } from 'dom-helpers';
import React, { Component } from 'react';







function PrivacyPolicyComponent() {
  
        return (
        <div>
            <div className="theme-layout">
            <div className="container-privacy pdng0">
              <div className="topbar transparent">
                <div className="logo">
                  <a title href="/"><img src="/assets/images/shareup_logo.png" alt="ShareUpTime" /></a>
                </div>
                <div className="top-area-land">
                  <ul className="setting-area">
                    <li><a href="/about" title="About" data-ripple>About</a></li>
                    <li><a href="/privacyPolicy" title="Home" data-ripple>Privacy
                        Bill of Rights</a></li>
                    <li><a href="#" title="Languages" data-ripple><i className="fa fa-globe" /></a>
                      <div className="dropdowns languages">
                        <a href="#" title><i className="ti-check" />English</a> <a href="#" title>Arabic</a> <a href="#" title>Dutch</a> <a href="#" title>French</a>
                      </div></li>
                      <li>
                      <a href="/" title><button className="shareIn-btn" type="button">
                        <span>Members Login</span>
                      </button></a></li>
                  </ul>
                </div>
              </div>
              <div className="policy">
              <h2 style={{color:"aquamarine", fontSize:"40px", fontWeight:"bold", textDecoration:"none" , textDecorationLine: 'underline' }} >SHAREUPTIME's Privacy Bill of Rights</h2>
              <div className="row">
              
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div className="policy-p">
              
    <div >
<div   className='scrollbar-privacy-terms' style={{width:'50vw',borderColor:'aquamarine' }}  >

          

       
        <br/>
  <br/>
  <br/>

          <p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className="text-justify">  
          Thank you for choosing to be part of our community at <b  className="font-weight-bold"> ShareUpTime</b>. We are committed to protecting your personal information 
          and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your
           personal information, please send a mail to <a  href="mailto:info@shareuptime.com" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}>info@shareuptime.com</a>.
           {/* Updated contact: info@shareuptime.com */}
            When you visit our  <a  href="https://www.shareuptime.com" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}>website </a> and use our
             <a style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }} href="https://www.shareuptime.com"> services</a>, you trust us with your personal information.
  
                                                                       
  <br/>
  <br/>
  <br/>

  
  We take your privacy very seriously. We seek to explain to you in the clearest way possible what information we collect, 
          how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. 
          If there are any terms in this privacy policy that you do not agree with, please discontinue use of our sites and our services. 
           This privacy policy applies to all information collected through our website such as <a href="https://www.shareuptime.com" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}> https://www.shareuptime.com </a> and/or any related services, 
           sales, marketing or events.


<br/>
<br/>
<br/>

<p style={{fontFamily: 'Helvetica, Arial, sans-serif', letterSpacing:'normal'}} className="font-weight-bold text-justify">
          
          Please read this privacy policy carefully as it will help you make informed decisions about sharing your personal information with us
          </p>

 
<br/>
             <br/>
             <br/>

             <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> WHAT INFORMATION DO WE COLLECT?  </b>

             <br/>
             <br/>
             <p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className="text-justify">

             We collect personal information that you voluntarily provide to us when registering at 
             <a href="https://www.shareuptime.com"  style={{color:"#a7dee5", fontSize:"20px", fontWeight:"bold", textDecoration:"none" }}> ShareUpTime </a> 
              expressing an
              interest in obtaining information about us or our products and services, when participating in activities on the Services or otherwise 
              contacting us. The personal information that we collect depends on the context of your interactions with us and the Services, the choices
               you make and the products and features you use. The personal information we collect can include the following:
               <br/>
               <br/>
     
</p>
<ul className="unorderedlist">
                 <li className="font-weight-bold">Name and Contact Data</li>
                 <br/>
                 
                 We collect your first and last name, email address, phone number, national ID number and other similar contact data.
                 <br/>
                 <br/>
                 <br/>
                 <li className="font-weight-bold">Credentials</li>
                 
                 <br/>
                 We collect passwords, password hints, and similar security information used for authentication and account access.
                 <br/>
                 <br/>
                 <br/>
                 
                 <li className="font-weight-bold">Social Media Login Data</li>
                 <br/>
                 
                 We provide you with the option to register using social media account details, like your Facebook, Twitter or other social media account.
                  If you choose to register in this way, we will collect the Information described in the section called "HOW DO WE HANDLE YOUR SOCIAL LOGINS" below.

               </ul>
               

               <br/>
                 <br/>
                 



All personal information that you provide to us must be true,
 complete and accurate, and you must notify us of any changes to such personal information.   
 </p>

 <br/>
                 <br/>
                 <br/>
                 <p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> HOW DO WE USE YOUR INFORMATION?  </b>
 <br/>
             <br/>

 We use the information we collect or receive:
<br/>
<br/>
 <ul className="unorderedlist">
                 <li className="font-weight-bold">To facilitate account creation and logon process</li>
                 <li className="font-weight-bold">To send you marketing and promotional communications</li>
                 <li className="font-weight-bold">To send administrative information to you</li>
                 <li className="font-weight-bold">Fulfill and manage your orders.</li>
                 <li className="font-weight-bold">To post testimonials</li>
                 <li className="font-weight-bold">Request Feedback</li>
                 <li className="font-weight-bold">To protect our Services</li>
                 <li className="font-weight-bold">To enable user-to-user communications</li>
                 <li className="font-weight-bold">To deliver services to the user. </li>
                 <li className="font-weight-bold">For other Business Purposes</li>
                 <br/>
                 
                 

               </ul>


</p>
<br/><br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
TRACKING AND COOKIES DATA  </b>
<br/>
<br/>

We use cookies and similar tracking technologies to track the activity on our Services and hold certain information. 
Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a 
website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to 
improve and analyze our Service. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, 
if you do not accept cookies, you may not be able to use some portions of our Service.


</p>
<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
DATA BREACH</b>
<br/>
<br/>
A privacy breach occurs when there is unauthorized access to or collection, use, disclosure, or disposal of personal information. 
You will be notified about data breaches when <b className="font-weight-bold">"ShareUpTime"</b> believes you are likely to be at risk of serious harm. For example, a data breach may be
 likely to result in serious financial harm or harm to your mental or physical well-being. 
<br/>
<br/>
In the event that <b className="font-weight-bold">"ShareUpTime"</b>becomes aware of a security breach which has resulted or may result in unauthorized access, use or disclosure of
personal information. <b className="font-weight-bold">"ShareUpTime"</b>will promptly investigate the matter and notify the applicable Supervisory Authority not later than 72 hours after
 having become aware of it unless the personal data breach is unlikely to result in a risk to the rights and freedoms of natural persons.  


</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 CONTROL FOR-DO-NOT-TRACK FEATURES</b>
<br/>
<br/>
Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or 
setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. 
No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser 
signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that
 we must follow in the future, we will inform you about that practice in a revised version of this privacy policy.  
</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 HOW DO WE HANDLE YOUR SOCIAL LOGINS</b>
<br/>
<br/>

Our Services offer you the ability to register and login using your third-party social media account details (like your Facebook or Twitter logins). 
Where you choose to do this, we will receive certain profile information about you from your social media provider. The profile Information we receive 
may vary depending on the social media provider concerned, but will often include your name, e-mail address, friends list, profile picture as well as
 other information you choose to make public.   
 <br/>
<br/>  
We will use the information we receive only for the purposes that are described in this privacy policy or that are otherwise made clear to you on the
 Services. Please note that we do not control and are not responsible for other uses of your personal information by your third-party social media 
 provider. We recommend that you review their privacy policy to understand how they collect, use, and share your personal information, and how you can
  set your privacy preferences on their sites and apps. 


</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 CHILDREN’S INFORMATION</b>
<br/>
<br/>

Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, 
and/or monitor and guide their online activity. Our Service does not address anyone under the age of 16 ("Children"). 
<br/>
<br/>
We do not knowingly collect personally identifiable information from anyone under the age of 16. If you are a parent or guardian and you are 
aware that your children have provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from 
children without verification of parental consent, we take steps to remove that information from our servers.

</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 DO WE MAKE UPDATES TO THIS POLICY</b>
 <br/>
<br/>
We may update this privacy policy from time to time. The updated version will be indicated by an updated “Revised” date and the updated version
 will be effective as soon as it is accessible. If we make material changes to this privacy policy, we may notify you either by prominently posting
  a notice of such changes or by directly sending you a notification. We encourage you to review this privacy policy frequently to be informed of how 
  we are protecting your information.  
 </p>

 <br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 HOW CAN YOU CONTACT US ABOUT THIS POLICY</b>
 <br/>
<br/>
If you have questions or comments about this policy, you may email us at: info@shareuptime.com  
<br/>
<br/>
</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> 
 GDPR POLICY</b>
 <br/>
<br/>

Blockchain Technology legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal
 Information we collect and the specific context in which we collect the information:
 <br/>
<br/>

<ul className="unorderedlist">
                 <li >Blockchain Technology needs to perform a contract with you</li>
                 <li >You have given Blockchain Technology permission to do so</li>
                 <li >Processing your personal information is in Blockchain Technology legitimate interests</li>
                 <li >Blockchain Technology needs to comply with the law</li>
                 
                 <br/>
                 
                 

               </ul>

<br/>
<br/>
Blockchain Technology will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will 
retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
<br/>
<br/>
If you are a resident of the European Economic Area (EEA), you have certain data protection rights and the operator aims to take reasonable steps to
 allow you to correct, amend, delete, or limit the use of your personal information. If you wish to be informed what personal information, we hold about
  you and if you want it to be removed from our systems, please contact us. 

</p>
<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> Privacy Bill of Rights</b>
<br/>
<br/>

In certain circumstances, you have the following data protection rights:  
<br/>
<br/>
<ul className="unorderedlist">
<li>You have the right to request access to your personal information that we store and have the ability to access your personal information. </li>
<li>You have the right to access, update or to delete the information we have on you.</li>
<li>You have the right to the right to withdraw consent, object data portability and rectification.</li>
<li>You have the right to request that we correct any personal information you believe is inaccurate.</li> 
<li>You also have the right to request us to complete the personal information you believe is incomplete. </li>
<li>You have the right to request the erase your personal information under certain conditions of this Policy. </li>
<li>You have the right to object to our processing of your personal information. </li>
<li>You have the right to seek restrictions on the processing of your personal information. </li>
<li>When you restrict the processing of your personal information, we may store it but will not process it further. </li>
<li>You have the right to be provided with a copy of the information we have on you in a structured, machine-readable, and commonly used format.</li>
<li>You also have the right to withdraw your consent at any time where the operator relied on your consent to process your personal information.</li>
	<li>You have the right to complain to a ‘Data Protection Authority’ about our collection and use of your personal information. </li>
</ul>
</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
For more information, please contact your local data protection authority in the ‘European Economic Area’ (EEA).
<br/>
<br/>
<ol className="orderedlist">
    <li>USER DATA </li>
    <br/>
<br/>
    We will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to
     your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that 
     relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any 
     such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.
     <br/>
<br/>
    <li>RETENTION OF PERSONAL IDENTITY INFORMATION</li>
    <br/>
<br/>
    We will retain and use your personal information for the period necessary to comply with our legal obligations, resolve disputes, and enforce our
     agreements unless a longer retention period is required or permitted by law. We may use any aggregated data derived from or incorporating your 
     personal information after you update or delete it, but not in a manner that would identify you personally. Once the retention period expires,
      personal information shall be deleted. Therefore, the right to access, the right to erasure, the right to rectification and the right to data
       portability cannot be enforced after the expiration of the retention period.
       <br/>
<br/>
    <li>USER REGISTRATION</li>
    <br/>
<br/>
    You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account 
    and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username
     is inappropriate, obscene, or otherwise objectionable.
     <br/>
<br/>
    <li>WEB DATA SUCH AS IP ADDRESS & COOKIE DATA  </li>
    <br/>
<br/>
    We automatically collect certain information when you visit, use, or navigate the  
     <a  href="https://www.shareuptime.com" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}> website</a>
    .  This information does not reveal
     your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser 
     and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about who and 
     when you use our and other technical information. This information is primarily needed to maintain the security and operation of our
     <a  href="https://www.shareuptime.com" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}> website </a>
     and for our internal analytics and reporting purposes.  Like many businesses, we also collect information through 
      cookies and similar technologies.
      <br/>
<br/>
    <li>ETHNIC DATA</li>
    <br/>
<br/>
    While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you
    <b className="font-weight-bold text-justify" style={{fontSize:'12'}}> (“Personal Data”). </b>
Personally identifiable information may include, but is not limited to:
<ul className="unorderedlist">
<li>Email address</li>
<li>First name and last name</li>
<li>Phone number</li>
<li>National ID</li>
<li>Address, Country, State, Province, ZIP/Postal code, City</li>
</ul>
<br/>
<br/>
While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship,
 registration at place of residence and actual address and telephone number (work, mobile). 
 <br/>
 <br/>
Whilst one of these signs on its own might not give cause for concern, two or more may give rise to a potential red flag. Use common sense and
 report any suspicious signs to the local authorities if you suspect sex/human trafficking.
 <br/>
 <br/>
 <b className="font-weight-bold text-justify" style={{fontSize:'12'}}> Note:</b> Please report any suspected sexual exploitation of minors and/or human trafficking to the appropriate authorities.

</ol>


</p>

<br/>
 <br/>
 <br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">

<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> Data Protection Rights under the California Privacy Protection Act (CalOPPA)</b>
<br/>
 <br/>
 CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches
  well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally
   identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being 
   collected and those individuals with whom it is being shared, and to comply with this policy.
   <br/>
 <br/>
According to CalOPPA we agree to the following:
<ul className="unorderedlist">
<li>Users can visit our site anonymously.</li>
<li>Our Privacy Policy link includes the word “Privacy” and can easily be found on the home page of our website.</li>
<li>Users will be notified of any privacy policy changes on our Privacy Policy Page.</li>
<li>Users can request to change their personal information by emailing us at info@shareuptime.com.</li>
</ul>
<br/>
 <br/>
<i style={{fontStyle:"italic"}}>Our Policy on “Do Not Track” Signals:</i>
<br/>
 <br/>
We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track 
is a preference you can set in your web browser to inform websites that you do not want to be tracked. You can enable or disable Do Not Track by 
visiting the Preferences or Settings page of your web browser.

</p>
<br/>
 <br/>
 <br/>
 <p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}> Data Protection Rights under the California Consumer Privacy Act (CCPA)</b>
 <br/>
 <br/>
 If you are a California resident, you are entitled to learn what data we collect about you, ask to delete your data and not to sell (share) it. To exercise your data protection rights, 
 you can make certain requests and ask us anytime.
</p>

<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<br/>
 <br/>
 <br/>
 <b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}>Qatar Data Protection Law</b>
 <br/>
 <br/>
 The Qatari Law No. 13 of 2016 ("the Personal Data Privacy Protection Law") took effect in 2017, with the aim of protecting and providing
  guidelines of processing personal data within Qatar. In December 2020, the Compliance and Data Protection Department (CDP) within the Ministry of
   Transport and Communications (MOTC) published new guidelines in relation to the Law. The scope of the PDPPL applies to personal data that is received,
  collected, extracted, or processed through electronic or traditional methods.
  <br/>
 <br/>
Any organization that processes such personal data must adhere to the principles of transparency, fairness, and respect for human dignity. 
The law has a large focus on organizations ensuring that the personal data they process is up to date and there are adequate measures in place
 for safe custody of the personal data.


 </p>

 <br/>
 <br/>
 <br/>
 <p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<br/>
 <br/>
 <br/>
 <b className="font-weight-bold text-justify" style={{fontSize:'16'}}>Rights of Individuals</b>
 <br/>
 <br/>
 Each Individual has the right to the protection of the Personal Data there of that shall be processed only within the framework of transparency, 
 honesty, and respect of human dignity, and acceptable practices according to provisions. The Controller shall process Personal Data only after 
 obtaining the consent of the Individual unless data processing is necessary to achieve a Lawful Purpose for the Controller or the other recipient of
  such data. 

  An Individual may at any time: 
  <br/>
 <br/>  
  <ul className="unorderedlist">
<li>Withdraw the prior consent thereof for Personal Data Processing. </li> 
<li>Object to processing the Personal Data thereof if such processing is not necessary to achieve the purposes for which such Personal Data have been
     collected or where such collected Personal Data are beyond the extent required, discriminatory, unfair or illegal. </li>  
<li>Request omission or erasure of the Personal Data thereof in any of the cases referred to in the preceding two items , upon cessation of the  purpose
     for which the processing has been conducted, or where all  justifications for maintaining such Personal Data by the Controller cease  to exist.  </li> 
<li>Request corrections to the Personal Data thereof. A request so made shall be accompanied with proof of the accuracy of such request.</li> 
</ul>

<br/>
 <br/>
An Individual may, at any time, access the Personal Data thereof and apply to review the same, in facing any Controller, and an Individual has,
 in particular, the right to:  
 <br/>
 <br/> 
 <ul className="unorderedlist">
 <li>Be notified of processing the Personal Data thereof and the purposes for which such processing is conducted.  </li> 
 <li>Be notified of any disclosure of inaccurate personal data</li> 
</ul>

</p>
<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16'}}>Consequences of non-compliance</b>
<br/>
<br/>
If your organization fails to protect personal data and comply with Law No. 13 then you are exposed to not only high financial penalties (ranging from 
QAR 1,000,000 to QAR 5,000,000 in fines) but operational inefficiencies, intervention by regulators, and most importantly permanent loss of your 
consumer trust.

 </p>

 <br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}>Bahrain Personal Data Protection Law</b>
<br/>
<br/>
On 1 August 2019, Bahrain Law No. 30 of 2018 promulgating the Personal Data Protection Law (PDPL) came into force in the Kingdom. Modelled on 
European Union data protection laws, the PDPL is the second national law in the Gulf region to directly address the right to personal data protection
 and will impose obligations on businesses that collect personal data in relation to how organizations use and secure it.
 <br/>
<br/>
<i style={{fontStyle:'italic'}}>Penalties go further than the GDPR by including provisions for
<b className="font-weight-bold text-justify" style={{fontSize:'12'}}> prison sentences of up to 1 year.</b></i>
<br/>
<br/>
The law includes additional requirements for organizations to submit their data processing registers monthly to the Authority and has shorter timelines
 for compliance with individuals' rights.


 </p>

 <br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}>Egypt Personal Data Protection Law</b>
<br/>
<br/>
Egypt published a Personal Data Protection Law in July 2020 that addresses the right to personal data protection and gives multiple rights to 
individuals. 
According to the Law, personal data should only be collected for specific legitimate purposes and should not be retained longer than necessary. 
Organizations may need to acquire a license to process both personal and sensitive personal data. Additionally, organizations involved in the processing 
of personal information are expected to appoint an authorized Data Protection Officer (DPO) who will be responsible for the application of this law
 within the organization. 
The Personal Data Protection Law has provisions for administrative fines and criminal penalties for non-compliance which could be up to a maximum of
<b className="font-weight-bold text-justify" style={{fontSize:'12'}}> EGP 5m</b> or a potential sentence of
 <b className="font-weight-bold text-justify" style={{fontSize:'16'}}> imprisonment of more than six months.</b> 
</p>

<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}>DIFC Data Protection Law</b>
<br/>
<br/>
The DIFC Data Protection Law (DIFC Law No. 5 of 2020) has been effective since 1 July 2020 and enforceable as of 1 October 2020. The DIFC law aims 
to safeguard the personal data of individuals whose data is processed by DIFC registered entities. It is heavily influenced by the EU General Data 
Protection Regulation (GDPR) as well as other world-class data protection laws.
<br/>
<br/>
Some of the key features of the new law include the clarification of data subjects’ rights, the facilitation of appropriate data sharing structures
 between governmental authorities, as well as the introduction of a framework that will support the DIFC’s bid for adequacy recognition by the European
  Commission and the UK, which will enable data transfers from the DIFC to the EU and the UK. Organizations may be subject to fines for non-compliance.

</p>
<br/>
<br/>
<br/>
<p style={{fontFamily: 'Helvetica, Arial, sans-serif',  fontWeight:'lighter',letterSpacing:'normal'}} className=" text-justify">
<b className="font-weight-bold text-justify" style={{fontSize:'16',textDecorationLine:'underline'}}>FREQUENTLY ASKED QUESTIONS (FAQs)</b>
<br/>
<br/>
<ol className="orderedlist-faq">
    <li><i style={{fontStyle:'italic'}}>What is ShareUpTime?</i></li>
  
    ShareUpTime is a social media platform that is integrated with blockchain technology. It enables the users to share and support each other 
    without fear.
    <br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>	What is Blockchain Technology?</i></li>
    Blockchain technology is most simply defined as a decentralized, distributed ledger that records the provenance of a digital asset. By inherent 
    design, the data on a blockchain is unable to be modified, which makes it a legitimate disruptor for industries like payments and cybersecurity.
    <a  href="https://builtin.com/blockchain" style={{color:"#a7dee5", fontSize:"20px",  textDecoration:"none" , textDecorationLine: 'underline' }}>
        (courtesy: https://builtin.com/blockchain)</a>
     <br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>Which devices is ShareUpTime available on?</i></li>
    ShareUpTime is available on Android or iOS smartphone, as well as on all desktops and tablets.
    <br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>What content can I share on ShareUpTime?</i></li>
    At ShareUpTime, you can safely share photos, videos, documents, voice messages, chats, gifts, memes, doodles, and more. You can communicate 1-to-1 
    and in private groups with your contacts, friends, family, co-workers, and in open groups with other ShareUpTime members with whom you share a common 
    interest or hobby.
    <br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>What are some unique features of ShareUpTime?</i></li>
    ShareUpTime is an advanced social network with features that give you total control, including:
    <ul className="unorderedlist">
	<li>Hangshare – Not only do you share images and videos but if you have more than you need then ShareUpTime enables you share or support other people.</li>
<li>Swap – If you want to swap anything with friends or public, ShareUpTime is the safe platform to do so. Real people real accounts </li>
	<li>KYC (Knowing Your Customer) – All the ShareUpTime accounts are verified and are registered with real identities.</li>
	<li>Universal tagging - This is a new, convenient way to sort and organize all the content you receive and share, making it easy to find everything, 
    anytime.</li>
	<li>Enhanced permission control (patent issued) - Manage permissions on a granular level and decide exactly who sees what. You can also remove
     yourself from the search directory, make yourself invisible to other members online, and much more.</li>
</ul>
<br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>Who can see the posts I share?</i></li>
   
    You control who receives and views your posts. Since there is no way to boost anything on ShareUpTime, you can be assured that your posts are shared 
    only with members you connect with. ShareUpTime does not spy on your private posts.
    <br/>
<br/>
    <li><i style={{fontStyle:'italic'}}>Can I delete my ShareUpTime account and is it easy to do this?</i></li>
 
    
    Yes! We make it easy to delete all your ShareUpTime content anytime, and to delete your account. To delete, first delete any groups you own or
     transfer ownership to another user. Once you are no longer an owner of any groups, you can quickly delete your account with the following steps:
     <br/>
     <br/>
     <ol className="unorderedlist">
<li>	Click on My Account in the upper right area of your screen.</li>
<li>Scroll down to Delete My Account at the bottom left area of the window prompt.</li>
</ol>
    
    <br/>
    <br/>
    <li><i style={{fontStyle:'italic'}}>	What is the GDPR?</i></li>
    
    The General Data Protection Regulation is a European Union law that was implemented May 25, 2018 and requires organizations to safeguard 
    personal data and uphold the privacy rights of anyone in EU territory. The regulation includes seven principles of data protection that must 
    be implemented and eight privacy rights that must be facilitated

</ol>
</p>
</div>     
             </div>

            </div>
          </div>


          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div style={{textAlign: 'center'}}>
            <div className="privacy-side">
            {/* { <img src="/assets/images/myimg.jpeg" style={{width:600 , height:200,position:'relative',right:5,top:5}} /> } */}
            </div>
            </div>

          </div>
        </div>
  

              </div>
              
            </div>
         
         
           
          </div>
         
        </div>
        
        );
    
}
export default PrivacyPolicyComponent;